import {
    SET_ALL_EXPLORE_DESIGNS,
    SET_DESIGN_FOR_FAVOURITE,
    SET_EXPLORE_DESIGNS_LOADING,
    SET_SEARCH_SESSION,
    CLEAR_SEARCH_SESSION,
    SET_SEARCH_QUERY,
    CLEAR_SEARCH_QUERY
} from '../../@types/thunk.types'

export const ExploreDesignReducer = {
    [SET_ALL_EXPLORE_DESIGNS]: (state, { payload }) => {
        let styles = []
        if (payload.merge) {
            styles = [...state.response.data, ...payload.data.data]
        } else {
            styles = [...payload.data.data]
        }
        payload.data.data = styles
        state.response = payload.data
        const sessionId = payload.data.summaryData?.searchSessionId
        if (sessionId) {
            state.searchSessionId = sessionId
        }
    },
    [SET_DESIGN_FOR_FAVOURITE]: (state, { payload }) => {
        state.response.data = state.response?.data?.map((item) => {
            if (item.id === payload) {
                item.liked = !item.liked
            }
            return item
        })
    },
    [SET_EXPLORE_DESIGNS_LOADING]: (state, { payload }) => {
        state.isLoading = payload
    },
    [SET_SEARCH_SESSION]: (state, { payload }) => {
        state.searchSessionId = payload
    },
    [CLEAR_SEARCH_SESSION]: (state) => {
        state.searchSessionId = null
    },
    [SET_SEARCH_QUERY]: (state, { payload }) => {
        state.searchQuery = payload
        state.searchSessionId = null
    },
    [CLEAR_SEARCH_QUERY]: (state) => {
        state.searchQuery = null
        state.searchSessionId = null
    }
}
